<app-exam-header></app-exam-header>
<div class="dashboard-container">
    <div class="row mx-0 mt-3">
        <div class="col-md-10 mx-auto">
            <div class="row mx-0">
                <div class="col-md-12 welcome-section text-center">
                    <div class="welcome-container">
                        <h4 class="welcome-subtitle">Welcome Back</h4>
                        <h2 class="welcome-title">{{userInfo?.displayName}}</h2>
                    </div>
                </div>
                <div class="col-md-12 pb-4">
                    <div class="enhanced-profile">
                        <div class="profile-header">
                            <div class="avatar-container">
                                <!-- <div class="avatar">
                                    {{userInfo?.displayName?.charAt(0) | uppercase}}{{userInfo?.displayName?.split(' ')[1]?.charAt(0) | uppercase}}
                                </div> -->
                                <!-- <div class="status-indicator online" matTooltip="Online"></div> -->
                            </div>
                            <div class="user-intro">
                                <div class="user-name-container d-flex align-items-center gap-2">
                                    <h2 class="user-name mb-0">{{userInfo?.displayName}}</h2>
                                    <i class="fa fa-pencil edit-icon" aria-hidden="true" (click)="openUserInfoDialog()"></i>
                                </div>
                                <p class="user-title">{{userInfo?.occupation || 'Student'}}</p>
                            </div>
                        </div>

                        <div class="profile-stats">
                            <div class="stat-item">
                                <div class="stat-icon">
                                    <i class="material-icons">smartphone</i>
                                </div>
                                <div class="stat-content">
                                    <span class="stat-label">Phone</span>
                                    <span class="stat-value">{{userInfo?.phone || 'Not provided'}}</span>
                                </div>
                            </div>

                            <div class="stat-item">
                                <div class="stat-icon">
                                    <i class="material-icons">email</i>
                                </div>
                                <div class="stat-content">
                                    <span class="stat-label">Email</span>
                                    <span class="stat-value">{{userInfo?.email || 'Not provided'}}</span>
                                </div>
                            </div>

                            <div class="stat-item highlight">
                                <div class="stat-icon">
                                    <i class="material-icons">workspace_premium</i>
                                </div>
                                <div class="stat-content">
                                    <span class="stat-label">Rewards</span>
                                    <span class="stat-value">{{getRewards()}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 mb-5">
                    <div class="book-status-card">
                        <div class="card-header">
                            <h3>Current Book Status</h3>
                            <div class="header-actions">
                                <span class="material-icons">auto_stories</span>
                            </div>
                        </div>
                        <div class="chapters-grid">
                            <div *ngFor="let p of userBookDetails; let i = index" class="chapter-card"
                                [ngClass]="{'completed': p.status === 'Completed', 'not-started': p.status === 'NotStarted'}">
                                <div class="card-content">
                                    <div class="status-indicator">
                                        <span class="status-badge" [ngClass]="p.status">
                                            <span class="material-icons status-icon">
                                                {{p.status === 'Completed' ? 'check_circle' : 'circle'}}
                                            </span>
                                            {{p.status}}
                                        </span>
                                    </div>
                                    <h4 class="chapter-title">
                                        {{p.chapterName ? p.chapterName : 'Chapter ' + (i+1)}}
                                    </h4>
                                    <div class="book-info">
                                        <div class="info-item">
                                            <span class="material-icons">menu_book</span>
                                            <span>{{p.bookName}}</span>
                                        </div>
                                        <div class="info-item">
                                            <span class="material-icons">event</span>
                                            <span>{{p.endDate ? p.endDate : 'No deadline'}}</span>
                                        </div>
                                    </div>
                                    <div class="card-actions">
                                        <button *ngIf="p.status === 'Completed'" (click)="takeQuiz(p)" 
                                        class="action-button edit-button" matTooltip="Edit self reflection questions">
                                            <span class="material-icons">check_circle</span>
                                            <span class="button-text">Edit Reflections</span>
                                        </button>

                                        <button *ngIf="p.status === 'NotStarted'" (click)="takeQuiz(p)"
                                            class="action-button complete-button" matTooltip="Answer self reflection questions">
                                            <span class="material-icons">quiz</span>
                                            <span class="button-text">Complete Reflections</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="celebration-container" *ngIf="showCelebration">
    <div class="celebration-text">Congratulations!</div>
    <div *ngFor="let confetti of confettiElements" class="confetti" [ngClass]="'c' + confetti.color" [ngStyle]="{
             'left': confetti.x + '%',
             'top': confetti.y + 'px',
             'width': confetti.size + 'px',
             'height': confetti.size + 'px',
             'animation-delay': confetti.delay + 's',
             'animation-duration': confetti.duration + 's'
         }">
    </div>
</div>
<app-exam-footer></app-exam-footer>